import chc from './chc.png';

const ChcLogo = (): JSX.Element => (
    <img alt="Certified CHC American Hospital Association" src={chc} />
);

export default ChcLogo;